import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import { DfpComponent } from "../../ads/dfp-component";
import { RowSeparator } from "../../atoms/RowSeparator";
import { useDeviceType } from "../../custom-hooks/useDeviceType";
import { StoryComponent } from "./StoryComponent";
import { PARTNER_CONTENT_STORY_TEMPLATE } from "../../../constants";

import "./top-component-home-page.m.css";

const TopComponentHomePage = ({ stories, collection, extraProp = "" }) => {
  const rowAdConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "top_component_home_page_top_ad"], {})
  );
  const {
    show_timestamp,
    show_read_time,
    show_column_separator,
    show_story_separator,
    show_row_separator,
    show_row_ad_unit,
    show_row_ad_unit_path,
    last_photo_stories_title,
    show_row_ad_unit_bottom,
    show_row_ad_unit_path_bottom,
  } = get(collection, ["associated-metadata"], {});

  const rowAd = show_row_ad_unit_path?.split("/").slice(-1)[0];
  const rowAdDivId = useSelector((state) => get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAd], ""));
  const rowAdBottom = show_row_ad_unit_path_bottom?.split("/").slice(-1)[0];
  const rowAdBottomDivId = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAdBottom], "")
  );

  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));
  const sectionSlug = extraProp;
  const deviceType = useDeviceType();
  const isMobile = deviceType === "mobile";

  if (stories.length === 0) {
    return null;
  }

  const mainStory = stories.slice(0, 1)[0];
  const primaryStories = stories.slice(1, 3);
  const leftFirstSecondaryStories = stories.slice(3, 5);
  const leftFirstTertiaryStories = stories.slice(5, 8);
  const leftSecondSecondaryStories = stories.slice(8, 10);
  const leftSecondTertiaryStories = stories.slice(10, 13);
  const rightFirstTertiaryStories = stories.slice(13, 16);
  const rightSecondTertiaryStories = stories.slice(16, 17)[0];
  const photoStories = stories.slice(17, 19);

  return (
    <div styleName="main-container" className="row-component">
      <div styleName="top-container">
        <div styleName="left-container">
          <div styleName="main-first-box">
            <div styleName="first-box">
              {primaryStories.map((story, index) => {
                return (
                  <Fragment key={index}>
                    <StoryComponent
                      story={story}
                      type="primary"
                      showImage={false}
                      showSubHeadline={true}
                      show_timestamp={show_timestamp}
                      show_read_time={show_read_time}
                      sectionSlug={sectionSlug}
                    />
                    {index < primaryStories.length - 1 && (
                      <div styleName={`${show_story_separator ? "horizontal-separator" : ""}`}></div>
                    )}
                  </Fragment>
                );
              })}
            </div>
            <div
              styleName={`${show_column_separator ? "verticle-separator" : ""} ${
                show_story_separator ? "mobile-horizontal-separator" : ""
              }`}
            ></div>
            <div styleName="midbox">
              <StoryComponent
                story={mainStory}
                showImage={true}
                type="main"
                showSubHeadline={true}
                show_timestamp={show_timestamp}
                show_read_time={show_read_time}
                sectionSlug={sectionSlug}
              />
            </div>
          </div>
          <div styleName={`${show_story_separator ? "horizontal-separator" : ""}`}></div>
          <div styleName="main-second-box">
            <div styleName="first-column">
              {leftFirstSecondaryStories.map((story, index) => (
                <Fragment key={index}>
                  <StoryComponent
                    story={story}
                    showImage={true}
                    showFallbackImage={true}
                    type="secondary"
                    show_timestamp={show_timestamp}
                    show_read_time={show_read_time}
                    sectionSlug={sectionSlug}
                  />
                  {index < leftFirstSecondaryStories.length - 1 && (
                    <div styleName={`${show_story_separator ? "horizontal-separator" : ""}`}></div>
                  )}
                </Fragment>
              ))}
              {leftFirstSecondaryStories.length > 0 && (
                <div
                  styleName={`${show_story_separator ? "horizontal-separator" : ""} ${
                    show_row_ad_unit ? "hidden-in-mobile" : ""
                  }`}
                ></div>
              )}
              {isMobile && show_row_ad_unit && show_row_ad_unit_path && (
                <div styleName="right-first-container-mobile">
                  <div styleName="top-ad-container">
                    <DfpComponent adStyleName="ad-slot-size-300x250-constant" id={rowAdDivId} />
                  </div>
                </div>
              )}
              {leftFirstTertiaryStories.map((story, index) => {
                const sponsor = get(story, ["metadata", "sponsored-by"], null);
                const isPartneredContent =
                  story["story-template"] === PARTNER_CONTENT_STORY_TEMPLATE || sponsor !== null;
                return (
                  <Fragment key={index}>
                    <StoryComponent
                      story={story}
                      showImage={isPartneredContent}
                      type={isPartneredContent ? "secondary" : "tertiary"}
                      show_timestamp={show_timestamp}
                      show_read_time={show_read_time}
                      showFallbackImage={false}
                      sectionSlug={sectionSlug}
                    />
                    {index < leftFirstTertiaryStories.length - 1 && (
                      <div styleName={`${show_story_separator ? "horizontal-separator" : ""}`}></div>
                    )}
                  </Fragment>
                );
              })}
            </div>
            <div
              styleName={`${show_column_separator ? "verticle-separator" : ""} ${
                show_story_separator ? "mobile-horizontal-separator" : ""
              }`}
            ></div>
            <div styleName="second-column">
              {leftSecondSecondaryStories.map((story, index) => (
                <Fragment key={index}>
                  <StoryComponent
                    story={story}
                    showImage={true}
                    type="secondary"
                    show_timestamp={show_timestamp}
                    show_read_time={show_read_time}
                    sectionSlug={sectionSlug}
                    showFallbackImage={true}
                  />
                  {index < leftSecondSecondaryStories.length - 1 && (
                    <div styleName={`${show_story_separator ? "horizontal-separator" : ""}`}></div>
                  )}
                </Fragment>
              ))}
              {leftSecondSecondaryStories.length > 0 && (
                <div styleName={`${show_story_separator ? "horizontal-separator" : ""}`}></div>
              )}
              {leftSecondTertiaryStories.map((story, index) => {
                const sponsor = get(story, ["metadata", "sponsored-by"], null);
                const isPartneredContent =
                  story["story-template"] === PARTNER_CONTENT_STORY_TEMPLATE || sponsor !== null;
                return (
                  <Fragment key={index}>
                    <StoryComponent
                      story={story}
                      showImage={isPartneredContent}
                      type={isPartneredContent ? "secondary" : "tertiary"}
                      show_timestamp={show_timestamp}
                      show_read_time={show_read_time}
                      showFallbackImage={false}
                      sectionSlug={sectionSlug}
                    />
                    {index < leftSecondTertiaryStories.length - 1 && (
                      <div styleName={`${show_story_separator ? "horizontal-separator" : ""}`}></div>
                    )}
                  </Fragment>
                );
              })}
            </div>
          </div>
        </div>
        <div
          styleName={`${show_column_separator ? "verticle-separator" : ""} ${
            show_story_separator ? "mobile-horizontal-separator" : ""
          }`}
        ></div>
        <div styleName="right-container">
          {!isMobile && show_row_ad_unit && show_row_ad_unit_path && (
            <div styleName="right-first-container">
              <div styleName="top-ad-container">
                {deviceType && <DfpComponent adStyleName="ad-slot-size-300x250-constant" id={rowAdDivId} />}
              </div>
            </div>
          )}
          <div styleName="right-second-container">
            <div styleName="right-second-nested-container">
              {rightFirstTertiaryStories.map((story, index) => {
                const sponsor = get(story, ["metadata", "sponsored-by"], null);
                return (
                  <Fragment key={index}>
                    <StoryComponent
                      story={story}
                      showImage={!!sponsor}
                      type="tertiary"
                      show_timestamp={show_timestamp}
                      show_read_time={show_read_time}
                      showFallbackImage={false}
                      sectionSlug={sectionSlug}
                    />
                    {index < rightFirstTertiaryStories.length - 1 && (
                      <div styleName={`${show_story_separator ? "horizontal-separator" : ""}`}></div>
                    )}
                  </Fragment>
                );
              })}
              {rightSecondTertiaryStories && (
                <div styleName={`${show_story_separator ? "horizontal-separator" : ""} hidden-in-tablet`}></div>
              )}
            </div>

            {photoStories.length > 0 && (
              <div styleName={`${show_column_separator ? "verticle-separator" : ""} show-in-tablet`}></div>
            )}
            {photoStories.length > 0 && (
              <div styleName="right-second-nested-container">
                <StoryComponent
                  story={rightSecondTertiaryStories}
                  showImage={false}
                  type="tertiary"
                  show_timestamp={show_timestamp}
                  show_read_time={show_read_time}
                  onlySponsoredImage={true}
                  showFallbackImage={false}
                  sectionSlug={sectionSlug}
                />
                <div styleName="photo-elements-separator-container">
                  <div styleName="photo-elements-separator"></div>
                  <div styleName="photo-element-text">{last_photo_stories_title}</div>
                  <div styleName="photo-elements-separator"></div>
                </div>
                {photoStories.map((story, index) => (
                  <Fragment key={index}>
                    <StoryComponent
                      story={story}
                      showImage={true}
                      showFallbackImage={true}
                      type="photo"
                      show_timestamp={show_timestamp}
                      show_read_time={show_read_time}
                      sectionSlug={sectionSlug}
                    />
                    {index < photoStories.length - 1 && (
                      <div styleName={`${show_story_separator ? "horizontal-separator" : ""}`}></div>
                    )}
                  </Fragment>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      {show_row_separator && <RowSeparator />}
      {show_row_ad_unit_bottom && <DfpComponent adStyleName="ad-slot-size-300x250" id={rowAdBottomDivId} />}
    </div>
  );
};

export default TopComponentHomePage;

TopComponentHomePage.storyLimit = 19;
